/**
 * Single entry for Firebase compat SDK. Import this instead of `firebase` or `firebase/app`.
 */
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/app-check';

export default firebase;
export { firebase };
export const firestore = firebase.firestore;
export const storage = firebase.storage;
